// WC — Hero shell loader (minimum visible skeleton time)
document.addEventListener('DOMContentLoaded', function () {
  // Root: product page only
  var root = document.querySelector('[data-section-type="product"]');
  if (!root) return;

  // Hero wrapper: this must wrap your main hero image
  var shell = root.querySelector('.wc-hero-shell');
  if (!shell) return;

  // The actual hero image inside the shell
  var img = shell.querySelector('img');
  if (!img) return;

  // Minimum time the skeleton should be visible (ms)
  var MIN_SKELETON_MS = 260;
  var start = (window.performance && performance.now) ? performance.now() : Date.now();

  function markLoaded() {
    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    var elapsed = now - start;
    var wait = Math.max(0, MIN_SKELETON_MS - elapsed);

    // Ensure the overlay animations have a tiny moment to breathe
    setTimeout(function () {
      shell.classList.add('wc-hero-loaded');
    }, wait);
  }

  // If the image is already cached, still show skeleton for a short moment
  if (img.complete && img.naturalWidth > 0) {
    markLoaded();
  } else {
    img.addEventListener('load', markLoaded, { once: true });
    img.addEventListener('error', markLoaded, { once: true });
  }
});
